import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { DiscountPromoSearchTypeContainer } from '../../containers/advancedFilters/DiscountPromoSearchTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const discountPromoSearchType: IFilter = {
  component: DiscountPromoSearchTypeContainer,
  availability: jsonQuery => isAvailable(FDealType.Sale, FOfferType.FlatNew)(jsonQuery),
};
